import dictionaries from '../locales';

export const getLocalizedLabel = (id: string, lang = 'ru') => (
  dictionaries[lang][id] || id
);
